import { render, staticRenderFns } from "./LiveGlobalMap.vue?vue&type=template&id=98ff4cfa&"
import script from "./LiveGlobalMap.vue?vue&type=script&lang=js&"
export * from "./LiveGlobalMap.vue?vue&type=script&lang=js&"
import style0 from "./LiveGlobalMap.vue?vue&type=style&index=0&id=98ff4cfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports